import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  complaintFormContent,
  ComplaintFormInitInterface,
  complaintFormLesson,
  complaintFormUser,
} from '@shared/complaint-form/complaint-form.constants';
import { DeviceDetectorService } from 'ngx-device-detector';

export type typeOfComplaint = 'user' | 'content' | 'lesson';

@Component({
  selector: 'app-complaint-form',
  templateUrl: './complaint-form.component.html',
  styleUrls: ['./complaint-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplaintFormComponent implements OnInit {
  @Input() type: typeOfComplaint = 'content';
  @Output() cancel = new EventEmitter<boolean>();
  @Output() send = new EventEmitter<{ comment: string; causeIdx: number }>();
  @ViewChild('input', { static: true }) inputRef: ElementRef;
  public sendInformation = false;
  public comment = '';
  public selectedCauseIdx: number;
  public init: ComplaintFormInitInterface;

  constructor(public deviceService: DeviceDetectorService) {}

  ngOnInit() {
    switch (this.type) {
      case 'user':
        this.init = complaintFormUser;
        break;
      case 'content':
        this.init = complaintFormContent;
        break;
      case 'lesson':
        this.init = complaintFormLesson;
        break;
    }
  }

  public onInput(e) {
    this.comment = e.target.innerText;
  }

  public onSend() {
    this.send.emit({ comment: this.comment, causeIdx: this.selectedCauseIdx });
    this.comment = '';
    this.selectedCauseIdx = null;
    this.inputRef.nativeElement.innerText = this.comment;
    this.sendInformation = true;
  }

  public onCancel() {
    this.cancel.emit(false);
  }

  public trackByFn(index) {
    return index;
  }
}
